import dayjs from 'dayjs';

/**
 * 获取日期差值
 * @param {Number} diff 差值
 * @param {String} type 以 'day' / 'month' 为单位
 * @param {Boolean} today 是否包含今天
 * @param {String} fmt 日期格式
 *
 * 使用方式：（以今天是 2018年12月20日 为例）
 *  getDiffDate(7) => { startDate: '2018-12-21', endDate: '2018-12-27' }
 *  getDiffDate(-7) => { startDate: '2018-12-13', endDate: '2018-12-19' }
 *  getDiffDate(7, { today: true }) => { startDate: '2018-12-20', endDate: '2018-12-26' }
 *  getDiffDate(-7, { today: true }) => { startDate: '2018-12-14', endDate: '2018-12-20' }
 *  getDiffDate(1, { type: 'month' }) => { startDate: '2018-12-21', endDate: '2018-1-20' }
 *  getDiffDate(-1, { type: 'month' }) => { startDate: '2018-11-20', endDate: '2018-12-19' }
 *  getDiffDate(1, { type: 'month', today: true }) => { startDate: '2018-12-20', endDate: '2018-1-19' }
 *  getDiffDate(-1, { type: 'month', today: true }) => { startDate: '2018-11-21', endDate: '2018-12-20' }
 */
export const getDiffDate = (
  diff,
  { type = 'day', today = false, format = true, fmt = 'YYYY-MM-DD', result = {} } = {}
) => {
  const startDiff = today ? 0 : diff > 0 ? 1 : -1;

  let startDate = dayjs()
    .add(today ? (diff >= 0 ? -1 : 1) : 0, 'day') // 包含今天则时间加1/减1
    .add(diff, type);
  let endDate = dayjs().add(startDiff, 'day');

  if (diff > 0) {
    [startDate, endDate] = [endDate, startDate];
  }

  startDate = format ? startDate.format(fmt) : startDate.toDate();
  endDate = format ? endDate.format(fmt) : endDate.toDate();

  if (Array.isArray(result)) {
    return [startDate, endDate];
  }

  return { startDate, endDate };
};

export const getMonthDate = (monthData = 0, fmt = 'YYYY-MM-DD') => {
  const date = dayjs();
  const year = date.year();
  const month = date.month();
  const firstDay = dayjs(new Date(year, month + monthData)).format(fmt);
  const lastDay = dayjs(new Date(year, month + monthData + 1, 0)).format(fmt);
  return [firstDay, lastDay];
};

/**
 * 格式化日期
 * @param {String} date 日期
 * @param {String} fmt 日期格式
 */
export const formatDate = (date, fmt = 'YYYY-MM-DD') => dayjs(date).format(fmt);

/**
 * 获取某年某月的总天数
 * @param {Number} year 年
 * @param {Number} month 月
 */
export const getMonthDays = (year, month) => dayjs(`${year}/${month}`).daysInMonth();

/**
 * 获取月份（首尾）
 * @param {Number} month 月份
 * @param {String} fmt 格式
 */
export const getBeginAndEndDateOfMonth = (month = 0, fmt = 'YYYY-MM-DD') => [
  dayjs()
    .add(month, 'month')
    .startOf('month')
    .format(fmt),
  dayjs()
    .add(month, 'month')
    .endOf('month')
    .format(fmt)
];

/**
 * 获取一段时间里的每一天
 * @param {String} begin 开始日期
 * @param {String} end 结束日期
 * @param {String} fmt 格式
 */
export const getAllGapDate = (begin, end, fmt = 'YYYY-MM-DD') => {
  let startDate = dayjs(begin);
  let endDate = dayjs(end);

  const days = [startDate.format(fmt)];

  while (!startDate.isSame(endDate)) {
    startDate = startDate.add(1, 'day');
    days.push(startDate.format(fmt));
  }

  return days;
};
/**
 * 获取时间插件日期范围内的时间格式
 * @param {String} startTime 开始日期
 * @param {String} dates 范围天数
 */
export const filterDefaultDate = (startTime, dates = 60) => {
  let dateAll = []
  // let i = 0
  let start = new Date(startTime || new Date())
  let end = new Date(startTime || new Date()).setDate(start.getDate() + dates - 1)
  while ((end - start.getTime()) >= 0) {
    let year = start.getFullYear()
    let month = (start.getMonth() + 1).toString().length === 1 ? '0' + (start.getMonth() + 1) : (start.getMonth() + 1).toString()
    let day = start.getDate().toString().length === 1 ? '0' + start.getDate().toString() : start.getDate().toString()
    dateAll.push({
      date: year + '-' + month + '-' + day,
      time: [['00', '24']]
    })
    start.setDate(start.getDate() + 1)
  }
  return dateAll
};
